var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "b-row",
          { staticClass: "justify-content-center" },
          [
            _c(
              "b-col",
              { attrs: { md: "6" } },
              [
                _c("div", { staticClass: "clearfix" }, [
                  _c("h1", { staticClass: "float-left display-3 mr-4" }, [
                    _vm._v("404"),
                  ]),
                  _c("h4", { staticClass: "pt-3" }, [
                    _vm._v(_vm._s(_vm.$t("404.heading"))),
                  ]),
                  _c("p", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("404.message"))),
                  ]),
                ]),
                _c(
                  "b-button",
                  {
                    attrs: { block: "", variant: "outline-primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.back()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("404.action")))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }